export const ROUTE_PATHS = {
  AMRAP: '/amrap',
  CLOCK: '/clock',
  EMOM: '/emom',
  HOME: '/',
  TABATA: '/tabata',
  TIME: '/time',
};
